import React from 'react';
import {
	MenuList,
	MenuListItem,
	MenuSection,
	MenuSectionHeading,
} from '@atlaskit/navigation-system';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../messages.tsx';
import type { RecentItemsType } from '../types.tsx';

export function RenderRecentSection({ recentItems }: { recentItems: RecentItemsType }) {
	const { formatMessage } = useIntl();

	return (
		recentItems.hasItems && (
			<MenuListItem testId="navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.recent-section.recent-section">
				<MenuSection>
					<MenuSectionHeading>{formatMessage(messages.recent)}</MenuSectionHeading>
					<MenuList>{recentItems.list}</MenuList>
				</MenuSection>
			</MenuListItem>
		)
	);
}
